<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<div class="container-fluid countdown-container text-center p-0 m-0 w-100">
  <div
    *ngIf="days > 0 || hours > 0 || minutes > 0 || seconds > 0"
    class="countdown-wrapper mx-auto"
  >
    <div
      class="countdown-inner d-flex justify-content-center align-items-center gap-4 w-100"
    >
      <div class="time-box" [ngClass]="animationClass.days">
        <span>{{ days }}</span>
        <p class="pb-0 mb-0">Days</p>
      </div>
      <div class="time-box" [ngClass]="animationClass.hours">
        <span>{{ hours }}</span>
        <p class="pb-0 mb-0">Hours</p>
      </div>
      <div class="time-box" [ngClass]="animationClass.minutes">
        <span>{{ minutes }}</span>
        <p class="pb-0 mb-0">Minutes</p>
      </div>
      <div class="time-box" [ngClass]="animationClass.seconds">
        <span>{{ seconds }}</span>
        <p class="pb-0 mb-0">Seconds</p>
      </div>
    </div>
  </div>
</div>
